var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarpenterTechnologyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Carpenter_Technology_RGB_NO_TECH",
    "data-name": "Carpenter_Technology_RGB NO TECH",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 206,
    height: 41,
    viewBox: "0 0 206 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_3",
    "data-name": "Clip 3",
    d: "M0,0H16.881V6.77H0Z",
    transform: "translate(0.026 0.17)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_8",
    "data-name": "Clip 8",
    d: "M0,0H91.677V30.961H0Z",
    transform: "translate(0 0.979)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_26",
    "data-name": "Clip 26",
    d: "M0,0H37.363V37.424H0Z",
    transform: "translate(0.06 0.616)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Carpenter_Technology_RGB"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M1.985,6.616a.092.092,0,0,1-.1-.1V1.09a.052.052,0,0,0-.059-.059H.1a.092.092,0,0,1-.1-.1V.1A.092.092,0,0,1,.1,0H4.826a.091.091,0,0,1,.1.1V.934a.091.091,0,0,1-.1.1H3.1a.052.052,0,0,0-.059.059V6.519a.092.092,0,0,1-.1.1H1.985",
    transform: "translate(63.345 34.277)",
    fill: "#d02144"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(76 34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_3-2",
    "data-name": "Clip 3",
    d: "M0,0H16.881V6.77H0Z",
    transform: "translate(0.026 0.17)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5-2",
    "data-name": "Group 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    "data-name": "Fill 2",
    d: "M0,.1A.092.092,0,0,1,.1,0H4.242a.092.092,0,0,1,.1.1V.934a.092.092,0,0,1-.1.1H1.206a.052.052,0,0,0-.058.059V2.7a.051.051,0,0,0,.058.058H3.765a.092.092,0,0,1,.1.1V3.7a.092.092,0,0,1-.1.1H1.206a.052.052,0,0,0-.058.059V5.526a.052.052,0,0,0,.058.059H4.242a.092.092,0,0,1,.1.1v.837a.092.092,0,0,1-.1.1H.1a.092.092,0,0,1-.1-.1V.1",
    transform: "translate(0.026 0.277)",
    fill: "#d02144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M0,3.415a5.118,5.118,0,0,1,.175-1.79A2.23,2.23,0,0,1,2.471,0,2.327,2.327,0,0,1,4.709,1.421a.085.085,0,0,1-.049.116l-.827.4a.086.086,0,0,1-.126-.049,1.309,1.309,0,0,0-1.236-.856,1.173,1.173,0,0,0-1.187.876,4.773,4.773,0,0,0-.117,1.508,4.777,4.777,0,0,0,.117,1.508A1.172,1.172,0,0,0,2.471,5.8a1.308,1.308,0,0,0,1.236-.855.086.086,0,0,1,.126-.049l.827.4a.085.085,0,0,1,.049.116A2.327,2.327,0,0,1,2.471,6.83,2.23,2.23,0,0,1,.175,5.2,5.118,5.118,0,0,1,0,3.415",
    transform: "translate(12.191 0.17)",
    fill: "#d02144"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M0,.1A.092.092,0,0,1,.1,0H1.05a.092.092,0,0,1,.1.1V2.7a.051.051,0,0,0,.058.058h2.52A.051.051,0,0,0,3.784,2.7V.1a.092.092,0,0,1,.1-.1h.954a.092.092,0,0,1,.1.1V6.519a.092.092,0,0,1-.1.1H3.881a.092.092,0,0,1-.1-.1V3.853a.052.052,0,0,0-.058-.059H1.206a.052.052,0,0,0-.058.059V6.519a.092.092,0,0,1-.1.1H.1a.092.092,0,0,1-.1-.1V.1",
    transform: "translate(100.794 34.277)",
    fill: "#d02144"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(114 9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_8-2",
    "data-name": "Clip 8",
    d: "M0,0H91.677V30.961H0Z",
    transform: "translate(0 0.979)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15-2",
    "data-name": "Group 15",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    "data-name": "Fill 7",
    d: "M0,.1A.092.092,0,0,1,.1,0H.992a.17.17,0,0,1,.165.1l2.7,4.563h.039V.1a.092.092,0,0,1,.1-.1h.847a.092.092,0,0,1,.1.1V6.519a.092.092,0,0,1-.1.1H3.949a.171.171,0,0,1-.165-.1l-2.7-4.554H1.041V6.519a.092.092,0,0,1-.1.1H.1a.092.092,0,0,1-.1-.1V.1",
    transform: "translate(0 25.277)",
    fill: "#d02144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_9",
    "data-name": "Fill 9",
    d: "M2.51,6.83A2.264,2.264,0,0,1,.175,5.235,5.384,5.384,0,0,1,0,3.415,5.376,5.376,0,0,1,.175,1.6,2.264,2.264,0,0,1,2.51,0,2.269,2.269,0,0,1,4.855,1.6,5.345,5.345,0,0,1,5.03,3.415a5.353,5.353,0,0,1-.176,1.821A2.269,2.269,0,0,1,2.51,6.83Zm0-5.8A1.188,1.188,0,0,0,1.285,1.9a5.087,5.087,0,0,0-.118,1.517,5.147,5.147,0,0,0,.118,1.518A1.188,1.188,0,0,0,2.51,5.8a1.2,1.2,0,0,0,1.236-.865,5.2,5.2,0,0,0,.117-1.518A5.135,5.135,0,0,0,3.746,1.9,1.2,1.2,0,0,0,2.51,1.031Z",
    transform: "translate(13.011 25.17)",
    fill: "#d02144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_10",
    "data-name": "Fill 10",
    d: "M0,.1A.092.092,0,0,1,.1,0h.954a.092.092,0,0,1,.1.1V5.526a.052.052,0,0,0,.058.059H4.241a.092.092,0,0,1,.1.1v.837a.092.092,0,0,1-.1.1H.1a.092.092,0,0,1-.1-.1V.1",
    transform: "translate(26.12 25.277)",
    fill: "#d02144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_11",
    "data-name": "Fill 11",
    d: "M2.51,6.83A2.262,2.262,0,0,1,.175,5.235,5.384,5.384,0,0,1,0,3.415,5.376,5.376,0,0,1,.175,1.6,2.262,2.262,0,0,1,2.51,0,2.269,2.269,0,0,1,4.855,1.6,5.345,5.345,0,0,1,5.03,3.415a5.353,5.353,0,0,1-.176,1.821A2.269,2.269,0,0,1,2.51,6.83Zm0-5.8A1.19,1.19,0,0,0,1.284,1.9a5.135,5.135,0,0,0-.117,1.517,5.2,5.2,0,0,0,.117,1.518A1.19,1.19,0,0,0,2.51,5.8a1.194,1.194,0,0,0,1.235-.865,5.147,5.147,0,0,0,.118-1.518A5.087,5.087,0,0,0,3.745,1.9,1.2,1.2,0,0,0,2.51,1.031Z",
    transform: "translate(37.808 25.17)",
    fill: "#d02144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_12",
    "data-name": "Fill 12",
    d: "M0,3.415A5.361,5.361,0,0,1,.175,1.6,2.282,2.282,0,0,1,2.539,0,2.33,2.33,0,0,1,4.845,1.4a.106.106,0,0,1-.039.136l-.817.36a.1.1,0,0,1-.126-.048A1.41,1.41,0,0,0,2.53,1.031,1.2,1.2,0,0,0,1.285,1.9a5.166,5.166,0,0,0-.118,1.518,5.211,5.211,0,0,0,.118,1.518A1.2,1.2,0,0,0,2.53,5.8a1.246,1.246,0,0,0,1.255-.826,2.754,2.754,0,0,0,.106-.857.051.051,0,0,0-.058-.058H2.743a.092.092,0,0,1-.1-.1V3.182a.092.092,0,0,1,.1-.1h2.19a.092.092,0,0,1,.1.1v.573A5.445,5.445,0,0,1,4.874,5.2,2.3,2.3,0,0,1,2.539,6.83,2.283,2.283,0,0,1,.175,5.235,5.368,5.368,0,0,1,0,3.415",
    transform: "translate(50.722 25.17)",
    fill: "#d02144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_13",
    "data-name": "Fill 13",
    d: "M2.02,6.616a.091.091,0,0,1-.1-.1V3.911L.006.1C-.014.049.016,0,.084,0h.983A.142.142,0,0,1,1.2.1L2.5,2.666h.029L3.83.1A.134.134,0,0,1,3.966,0H4.91c.078,0,.1.049.078.1L3.071,3.911V6.519a.092.092,0,0,1-.1.1H2.02",
    transform: "translate(63.134 25.277)",
    fill: "#d02144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_14",
    "data-name": "Fill 14",
    d: "M1.839,3.683A1.842,1.842,0,0,1,1.4.051,1.912,1.912,0,0,1,1.839,0a1.841,1.841,0,0,1,.308,3.658A1.922,1.922,0,0,1,1.839,3.683Zm0-3.37h0A1.531,1.531,0,0,0,1.6,3.357a1.622,1.622,0,0,0,.239.018A1.527,1.527,0,0,0,3,2.841,1.544,1.544,0,0,0,3.349,1.6,1.527,1.527,0,0,0,2.084.332,1.621,1.621,0,0,0,1.84.314Zm.617,2.463H2.284A.121.121,0,0,1,2.191,2.7l-.285-.64H1.525v.615a.1.1,0,0,1-.1.1H1.3a.1.1,0,0,1-.1-.1V1A.1.1,0,0,1,1.3.9h.727a.58.58,0,0,1,.63.572.541.541,0,0,1-.414.557l.153.3.153.3a.089.089,0,0,1,0,.089A.1.1,0,0,1,2.457,2.776ZM1.521,1.183v.586h.5a.291.291,0,0,0,.307-.293.281.281,0,0,0-.307-.293h-.5Z",
    transform: "translate(87.995 0.979)",
    fill: "#101517"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_16",
    "data-name": "Fill 16",
    d: "M2.717,18.787H0L8.208,0H10.9l8.207,18.785H16.282l-1.963-4.672H4.707l-1.99,4.672ZM9.5,2.828,5.651,11.8h7.724Z",
    transform: "translate(61.896 9.834)",
    fill: "#101517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_17",
    "data-name": "Fill 17",
    d: "M2.7,18.649H0V0H8.273a7.449,7.449,0,0,1,5.333,1.829,5.5,5.5,0,0,1,1.5,3.929v.055a5.469,5.469,0,0,1-4.363,5.523l-.476.137,5.117,7.173-3.146,0L7.487,11.9H2.7v6.744ZM2.7,2.4v7.2H8.024c2.631,0,4.331-1.407,4.331-3.585V5.951C12.355,3.725,10.726,2.4,8,2.4Z",
    transform: "translate(82.201 9.973)",
    fill: "#101517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_18",
    "data-name": "Fill 18",
    d: "M2.7,18.648H0V0H8.273a7.446,7.446,0,0,1,5.333,1.829,5.5,5.5,0,0,1,1.5,3.929v.055a5.8,5.8,0,0,1-1.179,3.6,6.2,6.2,0,0,1-3.265,2.117,14.038,14.038,0,0,1-3.693.379H2.7v6.743ZM2.7,2.4v7.2H8.025c2.63,0,4.33-1.407,4.33-3.585V5.951C12.355,3.725,10.726,2.4,8,2.4Z",
    transform: "translate(100.014 9.973)",
    fill: "#101517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_19",
    "data-name": "Fill 19",
    d: "M12.4,10.411V8.07H2.7V2.34H13.646V0H0V18.648H13.784V16.307H2.7v-5.9h9.7",
    transform: "translate(117.388 9.973)",
    fill: "#101517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_20",
    "data-name": "Fill 20",
    d: "M16.16,18.648V0H13.515V14.05L2.629,0H0V18.648H2.645V4.211l11.19,14.437H16.16",
    transform: "translate(133.606 9.973)",
    fill: "#101517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_21",
    "data-name": "Fill 21",
    d: "M15,0H0V2.451H6.136v16.2H8.864V2.451H15V0",
    transform: "translate(151.802 9.973)",
    fill: "#101517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_22",
    "data-name": "Fill 22",
    d: "M12.4,10.411V8.07H2.7V2.34H13.645V0H0V18.648H13.784V16.307H2.7v-5.9h9.7",
    transform: "translate(168.744 9.973)",
    fill: "#101517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_23",
    "data-name": "Fill 23",
    d: "M2.7,18.649H0V0H8.273a7.449,7.449,0,0,1,5.333,1.829,5.5,5.5,0,0,1,1.5,3.929v.055a5.469,5.469,0,0,1-4.362,5.523l-.476.137,5.116,7.173-3.147,0L7.487,11.9H2.7v6.744ZM2.7,2.4v7.2H8.025c2.63,0,4.33-1.407,4.33-3.585V5.951C12.355,3.725,10.726,2.4,8,2.4Z",
    transform: "translate(184.96 9.973)",
    fill: "#101517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_24",
    "data-name": "Fill 24",
    d: "M14.51,14.522a6.918,6.918,0,1,1,0-9.783L16.431,2.82a9.626,9.626,0,1,0-.006,13.621L14.51,14.522",
    transform: "translate(9.083 9.677)",
    fill: "#d02144"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_26-2",
    "data-name": "Clip 26",
    d: "M0,0H37.363V37.424H0Z",
    transform: "translate(0.06 0.616)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28-2",
    "data-name": "Group 28",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_25",
    "data-name": "Fill 25",
    d: "M12.826,25.527V23.392A10.629,10.629,0,1,1,23.393,12.774H25.53a12.767,12.767,0,1,0-12.7,12.753",
    transform: "translate(5.894 6.473)",
    fill: "#d02144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_27",
    "data-name": "Fill 27",
    d: "M1.193,18.655A17.519,17.519,0,1,1,18.6,36.228l0,1.195A18.712,18.712,0,1,0,0,18.651l1.193,0",
    transform: "translate(0 0.616)",
    fill: "#d02144"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_29",
    "data-name": "Fill 29",
    d: "M0,15.739A15.691,15.691,0,0,0,4.624,26.89L5.814,25.7a14.062,14.062,0,1,1,19.9-.049l1.187,1.186A15.741,15.741,0,1,0,0,15.739",
    transform: "translate(2.914 3.494)",
    fill: "#d02144"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_30",
    "data-name": "Fill 30",
    d: "M14.509,14.522a6.917,6.917,0,1,1,.005-9.783L16.432,2.82a9.627,9.627,0,1,0-.007,13.621l-1.916-1.919",
    transform: "translate(45.38 9.677)",
    fill: "#101517"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarpenterTechnologyLogo);
export default __webpack_public_path__ + "static/media/carpenter-technology-logo.92f29e2a98df441469e7fdb05e9c4090.svg";
export { ForwardRef as ReactComponent };